/* global Pjax */
var pjax;

document.addEventListener("pjax:send", function() {
    console.log("Event: pjax:send", arguments);
    jQuery('header').addClass('headroom--loading');
    jQuery('.loading-mask, main').removeClass('completed');

    if(jQuery('header').hasClass('headroom--menu-open')){
        setTimeout(function(){
            closeMenu();
        }, 50); 
    }
})

document.addEventListener("pjax:complete", function() {
    console.log("Event: pjax:complete", arguments);

    jQuery('.loading-mask').addClass('completed');

    jQuery('main').addClass('completed');
    jQuery('header').removeClass('headroom--loading');
    jQuery('header').removeClass('headroom--unpinned');
    jQuery('header').addClass('headroom--pinned');


    if(jQuery('nav.desktop').is(":visible")){
        var href = jQuery('nav.desktop li.current-menu-item a').attr('href');
        if (href != window.location) {
            jQuery('nav.desktop li.current-menu-item').removeClass('current-menu-item');
            jQuery('nav.desktop li').each(function(){
                href = jQuery(this).find('a').attr('href');
                if(href == window.location){
                    jQuery(this).addClass('current-menu-item');
                }
            })
        }
    }

    /* function defined in header atom */
    closeMenu();
    projectsSmall();
    imageCarousel();
    videoPopup();
    video();

});

document.addEventListener("pjax:error", function() {
    console.log("Event: pjax:error", arguments)
})

document.addEventListener("pjax:success", function() {
    console.log("Event: pjax:success", arguments);
})

document.addEventListener("DOMContentLoaded", function() {

    jQuery('main, .loading-mask').addClass('completed');

    pjax = new Pjax({
        elements: 'a:not(.no-pjax):not([target="_blank"])',
        selectors: ["head title", ".blocks-wrapper"],
        switches: {
            "head title": Pjax.switches.replaceNode,
            ".blocks-wrapper": Pjax.switches.sideBySide
        },
        switchesOptions: {
            ".blocks-wrapper": {
                classNames: {
                    // class added to the old element being replaced, e.g. a fade out
                    remove: "",
                    // class added to the new element that is replacing the old one, e.g. a fade in
                    add: "",
                    // class added on the element when navigating back
                    backward: "",
                    // class added on the element when navigating forward (used for new page too)
                    forward: ""
                }
            }
        },
        cacheBust: false,
        scrollRestoration: true,
    });

    header();
    projectsSmall();
    imageCarousel();
    videoPopup();
    textImage();
    video();
    mobileMenu();
});

function videoPopup(){
    jQuery('.video-popup-trigger').click(function () {
        var $this = jQuery(this);
        jQuery('.dark-page-overlay').addClass('active').addClass('video');
        setTimeout(function () {
            jQuery('.popup-container-close').addClass('active').fadeIn('fast');
            jQuery('.popup-container').addClass('active');
            jQuery('.popup-container').html('<iframe src="https://www.youtube.com/embed/' + $this.attr('data-embed') + '"></iframe>');
        }, 450);
        disableScroll();
    });

    jQuery('.popup-container-close').click(function () {
        if (jQuery(this).hasClass('active')) {
            jQuery('.popup-container').html('').removeClass('active');
            jQuery('.popup-container-close').removeClass('active').css('display', 'none');
            jQuery('.dark-page-overlay').removeClass('active').removeClass('video');
            enableScroll();
        }
    });
}
